import { render, staticRenderFns } from "./NewGrounded.vue?vue&type=template&id=7d63f4b4&"
import script from "./NewGrounded.vue?vue&type=script&lang=js&"
export * from "./NewGrounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports